module.exports = __webpack_public_path__ + "static/media/searchImg.1288a3b3.svg";